import { memo } from 'react';
import { Popover as RACPopover, PopoverProps as RACPopoverProps } from 'react-aria-components';

import { merge } from '@/components';

export type PopoverProps = RACPopoverProps;

const IPopover = ({ className, children, ...rest }: PopoverProps) => {
  /* prettier-ignore */
  const styles = [
    'bg-white',
    'border-1',
    'border-gray-200',
    'flex',
    'gap-2',
    'outline-none',
    'p-1',
    'rounded-lg',
  ];

  return (
    <RACPopover className={merge(styles, className)} {...rest}>
      {children}
    </RACPopover>
  );
};

export const Popover = memo(IPopover) as typeof IPopover;
